export default __webpack_public_path__ + "static/media/pic2.0f008728.webp";